import { Component, AfterViewInit, ElementRef, OnInit, Renderer2, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AppModalOverlayRef } from 'src/app/shared/services/app-modal.service';

@Component({
  standalone: false,
  selector: 'app-modal-confirmation',
  templateUrl: './modal-confirmation.component.html',
  styleUrls: ['./modal-confirmation.component.scss']
})
export class ModalConfirmationComponent implements OnInit, AfterViewInit {

  title: string = '';
  closeButton: boolean = false;
  modalTitleType: 'error' | 'warning' | 'success' | 'pattern' = 'pattern';
  modalType: 'info'| 'confirmation' | 'info-ok' | 'error' = 'info';
  content: string = '';
  confirmation: boolean = false;
  buttonOk: boolean = false;
  redirectButtonOk: boolean = false;
  redirectRouter: string = '';
  supportB3Button: boolean = false;
  operationConsult: boolean = false;
  tryAgainButton: boolean = false;
  newTransferenceButton: boolean = false;
  open = true;

  constructor(
   public dialogRef: AppModalOverlayRef,
   private router: Router,
   private el: ElementRef,
   private renderer: Renderer2,
   private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.setVariables();
  }

  ngAfterViewInit(): void {
    // Keep host out of document flow; b3-modal handles overlay.
    this.renderer.setStyle(this.el.nativeElement, 'display', 'contents');
  }

  get headerIcon(): string {
    switch (this.modalTitleType) {
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      case 'success':
        return 'check_circle';
      default:
        return 'info';
    }
  }

  get headerIconTone(): string {
    switch (this.modalTitleType) {
      case 'error':
        return 'danger';
      case 'warning':
        return 'warning';
      case 'success':
        return 'success';
      default:
        return 'default';
    }
  }

  get safeContent(): string {
    return this.sanitizer.sanitize(SecurityContext.HTML, this.content) ?? '';
  }

  confirm(): void{
    this.dialogRef.data = {
      ...this.dialogRef.data,
      confirmation: true
    };
    this.open = false;
    this.dialogRef.close(this.dialogRef.data as never);
  }

  close(): void{
    this.open = false;
    this.dialogRef.close();
  }

  confirmWithButtonOk(): void{
    if (this.redirectButtonOk && this.redirectRouter) {
      this.router.navigate([`/${this.redirectRouter}`]);
    }
    this.open = false;
    this.dialogRef.close(this.dialogRef.data as never);
  }

  closeToSupport(): void {
    window.open('https://atendimento.b3.com.br/atendeb3', '_blank');
    this.close();
  }

  setVariables(): void{
    const data = this.dialogRef.data;
    if(data) {
      this.title = (data['title'] as string) ?? '';
      this.modalTitleType = (data['modalTitleType'] as typeof this.modalTitleType) ?? 'pattern';
      this.modalType = (data['modalType'] as typeof this.modalType) ?? 'info';
      this.content = (data['content'] as string) ?? '';
      this.confirmation = (data['confirmation'] as boolean) ?? false;
      this.closeButton = (data['closeButton'] as boolean) ?? false;
      this.buttonOk = (data['buttonOk'] as boolean) ?? false;
      this.redirectButtonOk = (data['redirectButtonOk'] as boolean) ?? false;
      this.redirectRouter = (data['redirectRouter'] as string) ?? '';
      this.supportB3Button = (data['supportB3Button'] as boolean) ?? false;
      this.operationConsult = (data['operationConsult'] as boolean) ?? false;
      this.tryAgainButton = (data['tryAgainButton'] as boolean) ?? false;
      this.newTransferenceButton = (data['newTransferenceButton'] as boolean) ?? false;
    }
  }
}
